"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Err = exports.Ok = void 0;
var main_1 = require("./main");
Object.defineProperty(exports, "Ok", { enumerable: true, get: function () { return main_1.Ok; } });
Object.defineProperty(exports, "Err", { enumerable: true, get: function () { return main_1.Err; } });
//# sourceMappingURL=index.js.map